module.exports = __webpack_public_path__ + "static/img/card2.5d422d65.jpg";